<template>
<!--
  The side column of a Prepr product page: how it works, FAQs and testimonials.
  Lifted from BloodDetails alongside PreprProductDetails, for the same reason.
-->
  <!-- 4 col row starts here -->
  <div class="details-cards-grid-row">
    <div v-for="(widget, index) in product.how_it_works_widget" :key="index">
      <!-- row starts here -->
      <div class="head-details-row">
        <div>
          <h3>{{ widget.number }}</h3>
        </div>
        <div>
          <img class="widget-img" :src="widget?.icon?.[0]?.url" alt="" />
        </div>
      </div>
      <!-- row ends here -->
      <div class="card-content">
        <p>{{ widget.title }}</p>
        <p>
          {{ widget.body }}
        </p>
      </div>
    </div>
  </div>
  <!-- 4 col row ends here -->

  <!-- FAQS Component starts here -->
  <div class="faqs-details-blood-row">
    <h2>{{ product.faq_header }}</h2>
    <!-- accoridion component  -->
    <nav class="accordion arrows">
      <div v-for="(faq, index) in product.faqs" :key="index">
        <input type="radio" name="accordion" :id="`cb1${index}`" />
        <section class="box">
          <label class="box-title" :for="`cb1${index}`"
            >{{ faq.question }}</label
          >
          <label class="box-close" for="acc-close"></label>
          <div class="box-content" v-html="faq.answer">
          </div>
        </section>
      </div>
    </nav>
    <!-- accordion component -->
  </div>
  <!-- FAQS Component ends here -->

  <!-- Testimonial component starts here -->
  <div class="testimonial-row">
    <h3>{{ product.testimonials_header }}</h3>
    <div v-for="(testi, index) in product.testimonials" :key="index">
      <div>
        <img class="testimonial-image" :src="testi?.background?.[0]?.url" alt="" />
        <div class="star-rating">
          <span v-for="star in maxStars" :key="star" @click="setRating(star)">
            <i
              :class="[
                star <= testi.rating ? 'fa-solid fa-star' : 'fa-regular fa-star',
              ]"
            ></i>
            <!-- <i class="fa-regular fa-star"></i> -->
          </span>
        </div>
        <h4>{{ testi.author }}</h4>
        <p>
          {{ testi.body }}
        </p>
      </div>
    </div>
  </div>
  <!-- Testimonial component ends here -->
</template>

<script setup>
import { ref, defineProps } from "vue";
import "@/styles/pages/BloodTestDetails.scss";

defineProps({
  // A Prepr ProductPage, as getProductData returns it.
  product: { type: Object, required: true },
});

const rating = ref(3);
const maxStars = 5;

const setRating = (star) => {
  rating.value = star;
};
</script>
